import n from "./design-system.es942.js";
function i(e, o, t) {
  var r = t.getCountryCodesForCallingCode(e);
  if (r)
    return r.length === 1 ? r[0] : n(r, o, t.metadata);
}
export {
  i as default
};
//# sourceMappingURL=design-system.es887.js.map
